import { render, staticRenderFns } from "./MentionPicker.vue?vue&type=template&id=65d9bfc0&scoped=true"
import script from "./MentionPicker.vue?vue&type=script&lang=js"
export * from "./MentionPicker.vue?vue&type=script&lang=js"
import style0 from "./MentionPicker.vue?vue&type=style&index=0&id=65d9bfc0&prod&lang=scss&scoped=true"
import style1 from "./MentionPicker.vue?vue&type=style&index=1&id=65d9bfc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d9bfc0",
  null
  
)

export default component.exports